// ImageTile.tsx
import React, { memo } from 'react';
import './ImageTile.styles.scss';
import classNames from 'classnames';
import SmartMedia from '../SmartMedia/SmartMedia';
import { ImageTileProps } from '@/atoms';

const ImageTile: React.FC<ImageTileProps> = ({
  overlayText,
  bottomOverlayText,
  bottomRightOverlayText,
  checked,
  imgUrl,
  altText,
  disabled = false,
  translate,
  as,
  className,
  generated = false,
  ...rest
}) => {
  // Safe fallback to 'figure' if as is not a valid tag or component
  const HTMLTag =
    typeof as === 'string' || typeof as === 'function' ? as : 'figure';

  if (!HTMLTag) {
    console.error('Invalid `as` prop passed to ImageTile:', HTMLTag);
    return null;
  }

  return HTMLTag ? (
    <HTMLTag
      {...rest}
      className={classNames('image-tile-component', className, {
        'image-tile-disabled': disabled,
      })}
    >
      {imgUrl && (
        <SmartMedia
          src={imgUrl}
          alt={altText}
          className={classNames('image-tile-img', {
            'image-tile-generated-img': generated,
          })}
        />
      )}

      {overlayText && (
        <div className="image-tile image-tile-overlay">
          <span className="image-tile-overlay-text ods-typography-body-s-bold">
            {translate(overlayText)}
          </span>
        </div>
      )}

      {bottomOverlayText && (
        <div className="image-tile-bottom-overlay">
          <span className="image-tile-bottom-overlay-text ods-typography-microcopy-bold">
            {translate(bottomOverlayText)}
          </span>
        </div>
      )}

      {bottomRightOverlayText && (
        <div className="image-tile-bottom-right-overlay">
          <span className="image-tile-bottom-right-overlay-text ods-typography-microcopy-bold">
            {translate(bottomRightOverlayText)}
          </span>
        </div>
      )}

      {checked && <div className="image-tile image-tile-checked-overlay" />}
    </HTMLTag>
  ) : null;
};

ImageTile.displayName = 'ImageTile';
export default memo(ImageTile);
